import merge from 'deepmerge';
import find from 'lodash/find';
import forEach from 'lodash/forEach';

export default function formatConfig(receivedConfig, source) {
  const originalConfig = { ...receivedConfig };

  if (!source) {
    return originalConfig;
  }

  if (originalConfig.source === source) {
    return originalConfig;
  }

  const partySourceConfig =
    originalConfig.sources && originalConfig.sources.length > 0
      ? find(originalConfig.sources, item => item.source === source)
      : null;

  if (partySourceConfig) {
    const newConfig = merge(originalConfig, partySourceConfig);

    const sourceFiles = () => {
      if (partySourceConfig.files && partySourceConfig.files.length > 0) {
        const formatedFiles = [];
        forEach(originalConfig.files, file => {
          const newFile = partySourceConfig.files.find(sourceFile => sourceFile.name === file.name);
          file = newFile ? merge(file, newFile) : file;

          return formatedFiles.push(file);
        });

        return formatedFiles;
      }

      return originalConfig.files;
    };

    newConfig.files = sourceFiles();
    delete newConfig.sources;

    return newConfig;
  }

  return originalConfig;
}
